import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';

@Component({
  selector: 'app-redirect',
  template: '',
})
export class RedirectComponent {
  constructor(private route: ActivatedRoute, private router: Router,private encryptDecryptService: EncryptDecryptService) { 

  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = Number(params['id']);
        this.checkValidation() 
    });

  }


  checkValidation() {
    const encryptedData = sessionStorage.getItem('u.');
  
    if (encryptedData !== null) {
      const decryptedData = this.encryptDecryptService.decryptUsingAES256(encryptedData);
  
      // Check if decryptedData is not empty
      if (decryptedData) {
        try {
          let userDetails = JSON.parse(decryptedData);
  
          if (userDetails.token) {
            const isjwtToken = userDetails.token;
  
            const decodedToken: any = this.encryptDecryptService.decodeJwtToken(isjwtToken);
  
            // Check if the token is expired
            if (decodedToken.exp && decodedToken.exp * 1000 < Date.now()) {
              this.router.navigateByUrl('/login');
              return false;
            } else {
              this.router.navigateByUrl('/patient/invoices'); 
              return true;
            }
          }
        } catch (error) {
          // Handle error in case of malformed JSON or decryption issue
          console.error('Error parsing decrypted data:', error);
          this.router.navigateByUrl('/login');
          return false;
        }
      } else {
        // Decrypted data is empty or invalid
        this.router.navigateByUrl('/login');
        return false;
      }
    }
  
    // If encrypted data is not found
    this.router.navigateByUrl('/login');
    return false;
  }
  
}
